import { render, staticRenderFns } from "./TermosCondicoes.vue?vue&type=template&id=06ed672e&scoped=true"
import script from "./TermosCondicoes.vue?vue&type=script&lang=js"
export * from "./TermosCondicoes.vue?vue&type=script&lang=js"
import style0 from "./TermosCondicoes.vue?vue&type=style&index=0&id=06ed672e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ed672e",
  null
  
)

export default component.exports